import { Check, Loader2 } from "lucide-react";
import { FormField } from "@/components/common/FormField";
import { PhoneField } from "@/components/common/PhoneField";
import { useContactForm } from "@/hooks/useContactForm";

const ContactFields = ({ form, errors, updateField }) => (
  <>
    <div className="grid gap-5 md:grid-cols-2">
      <FormField label="Your name" error={errors.name} testId="contact-name">
        <input className="scc-cinput" value={form.name} data-testid="contact-name"
          onChange={(event) => updateField("name", event.target.value)} placeholder="Jordan Rivera" />
      </FormField>
      <FormField label="Email" error={errors.email} testId="contact-email-input">
        <input type="email" className="scc-cinput" value={form.email} data-testid="contact-email-input"
          onChange={(event) => updateField("email", event.target.value)} placeholder="you@company.com" />
      </FormField>
    </div>
    <FormField label="Phone number" error={errors.phone} testId="contact-phone">
      <PhoneField dial={form.phoneDial} number={form.phone} testId="contact-phone"
        onDial={(value) => updateField("phoneDial", value)} onNumber={(value) => updateField("phone", value)} />
    </FormField>
    <FormField label="Message" error={errors.message} testId="contact-message">
      <textarea rows={4} className="scc-cinput resize-none" value={form.message} data-testid="contact-message"
        onChange={(event) => updateField("message", event.target.value)} placeholder="How can SCC help?" />
    </FormField>
  </>
);

const ContactSuccess = () => (
  <div className="flex items-center gap-3 rounded-2xl border border-border bg-white p-8" data-testid="contact-success">
    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white"><Check className="h-6 w-6" /></span>
    <div>
      <p className="font-heading text-lg font-bold text-slate-900">Message sent.</p>
      <p className="text-slate-600">Thank you — we'll be in touch.</p>
    </div>
  </div>
);

export const ContactForm = () => {
  const contact = useContactForm();
  if (contact.status === "done") return <ContactSuccess />;
  const sending = contact.status === "sending";
  return (
    <form onSubmit={contact.submit} className="grid gap-5 rounded-2xl border border-border bg-white p-8" data-testid="contact-form" noValidate>
      <ContactFields {...contact} />
      <button type="submit" disabled={sending} data-testid="contact-submit"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-8 py-3.5 font-medium text-primary-foreground transition-[background-color] hover:bg-blue-700 disabled:opacity-60">
        {sending && <Loader2 className="h-4 w-4 animate-spin" />}
        {sending ? "Sending…" : "Send message"}
      </button>
    </form>
  );
};